import { Button } from 'antd';
import { Popover } from 'antd';
import { divide } from 'lodash';
import { employeeDTO } from '../../../../models/RightsDTO';
import { updateRightsValue } from '../../../../../actions/rights';
import { useDispatch } from 'react-redux';
import { useQueryClient } from 'react-query';
import { useUpdateEmployee } from '../../../../../hooks/useQuery/rights/crudEmployees';
import { withStyles } from '@material-ui/core/styles';
import Checkbox from '@mui/material/Checkbox';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import React, { useState } from 'react';

import { Tooltip } from '@material-ui/core';
import isOpenIcon from '../../../../../assets/images/rights/isOpen.png';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { CompanyDTO } from '../../../../models/ProjectDTO';

const AccordionDetails = withStyles(() => ({
  root: {
    backgroundColor: 'white',
    margin: 0,
    padding: 0,
    // padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

export type AccordionRawEmployeeProps = {
  columnSize: {
    expandIcon: string;
    licence: string;
    users: string;
    mails: string;
    company: string;
    admin: string;
    delete: string;
  };
  employee: employeeDTO;
  company: CompanyDTO;
};

const AccordionRawEmployee = ({
  columnSize,
  employee,
  company,
}: AccordionRawEmployeeProps) => {
  const dispatch = useDispatch();
  const licenceType = employee.licenseType;
  const [visibleLicenceManagement, setVisibleLicenceManagement] = useState(false);
  const [visibleAdminManagement, setVisibleAdminManagement] = useState(false);

  const [newLicenceType, setNewLicenceType] = useState({
    licenseType: employee.licenseType,
  });
  const [newIsAdmin, setNewIsAdmin] = useState({ isAdmin: employee.isAdmin });
  const { t } = useTranslation();

  // console.log('employee', employee)

  const onSuccessPatchEmployee = () => {
    const patchType = visibleLicenceManagement ? 'licence' : 'admin';

    queryClient.invalidateQueries('employees');
    dispatch(
      updateRightsValue(
        'snackbarMessage',
        `${
          patchType === 'licence'
            ? t('APP.ACCORDIONRAWEMPLOYEE.ACCORDIONRAWEMPLOYEE.PH_55EB90', {
                defaultValue: "La licence de l'utilisateur à bien été mise à jour",
              })
            : t('APP.ACCORDIONRAWEMPLOYEE.ACCORDIONRAWEMPLOYEE.PH_304249', {
                defaultValue: "Le statut de l'utilisateur a été mis à jour",
              })
        }`
      )
    );
    dispatch(updateRightsValue('snackbarSeverity', 'success'));
    dispatch(updateRightsValue('isSnackbarOpen', true));
    setVisibleLicenceManagement(false);
    setVisibleAdminManagement(false);
  };

  const onErrorPatchEmployee = (error) => {
    console.log('error dans le on error', error.response);

    const response = error?.response;

    let message = t('APP.ACCORDIONRAWEMPLOYEE.ACCORDIONRAWEMPLOYEE.PH_52C4A8', {
      defaultValue: "Une erreur c'est produit",
    });

    if (response?.status === 403) {
      const date = dayjs(response.data);
      const dateFormatted = date.format('L');

      message = t(
        'APP.ACCORDIONRAWEMPLOYEE.ACCORDIONRAWEMPLOYEE.PH_FCF641',

        {
          dateFormatted,
          defaultValue:
            "La licence est bloquée pour une durée de 1 mois suite à son affectation. Elle sera à nouveau modifiable le {dateFormatted} avec la date à laquelle le blocage s'arrête",
        }
      );
    }
    if (response?.status === 401) {
      message = t('APP.ACCORDIONRAWEMPLOYEE.ACCORDIONRAWEMPLOYEE.PH_F22E76', {
        defaultValue: "Vous n'avez pas les droits pour effectuer cette action",
      });
    }

    dispatch(updateRightsValue('snackbarMessage', message));
    dispatch(updateRightsValue('snackbarSeverity', 'error'));
    dispatch(updateRightsValue('isSnackbarOpen', true));
    setVisibleLicenceManagement(false);
    setVisibleAdminManagement(false);
  };

  const queryClient = useQueryClient();
  const { mutate: patchEmployee, isLoading } = useUpdateEmployee(
    onSuccessPatchEmployee,
    onErrorPatchEmployee
  );

  // TODO_TRAD : en ???
  const renderLicenceTypeManagement = () => {
    return (
      <div
        className="PopupLicenceTypeManagement"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}
        >
          <Checkbox
            checked={newLicenceType.licenseType === 'pro'}
            onClick={() => {
              setNewLicenceType({ licenseType: 'pro' });
            }}
            sx={{
              '&.Mui-checked': {
                color: '#91E391',
              },
            }}
          />
          <div className="tag pro">Pro</div>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}
        >
          <Checkbox
            checked={newLicenceType.licenseType === 'light'}
            onClick={() => {
              setNewLicenceType({ licenseType: 'light' });
            }}
            sx={{
              '&.Mui-checked': {
                color: '#6EE8CB',
              },
            }}
          />
          <div className="tag light">Light</div>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}
        >
          <Checkbox
            checked={newLicenceType.licenseType === 'read'}
            onClick={() => {
              setNewLicenceType({ licenseType: 'read' });
            }}
            sx={{
              '&.Mui-checked': {
                color: '#97F1E6',
              },
            }}
          />
          <div className="tag readOnly">Read-Only</div>
        </div>
        <div className="footerLicence">
          <div style={{ margin: '0 4px' }}>
            <Button
              shape="round"
              style={{
                fontSize: window.screen.availHeight > 950 ? '0.9rem' : '0.85rem',
              }}
              onClick={() => {
                setVisibleLicenceManagement(false);
              }}
            >
              {t('APP.ACCORDIONRAWEMPLOYEE.ACCORDIONRAWEMPLOYEE.PH_2C1871', {
                defaultValue: 'Annuler',
              })}
            </Button>
          </div>
          <div style={{ margin: '0 4px' }}>
            <Button
              shape="round"
              style={{
                fontSize: window.screen.availHeight > 950 ? '0.9rem' : '0.85rem',
              }}
              loading={isLoading}
              onClick={() => {
                patchEmployee({ employee, data: newLicenceType });
              }}
            >
              Valider
            </Button>
          </div>
        </div>
      </div>
    );
  };

  const renderAdminManagement = () => {
    return (
      <div
        className="PopupLicenceTypeManagement"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}
        >
          <Checkbox
            checked={newIsAdmin.isAdmin === true}
            onClick={() => {
              setNewIsAdmin({ isAdmin: !newIsAdmin.isAdmin });
            }}
            sx={{
              '&.Mui-checked': {
                color: '#779ADE',
              },
            }}
          />

          <div className={`tag ${newIsAdmin.isAdmin ? 'isAdmin' : 'isNotAdmin'}`}>
            {t('APP.ACCORDIONRAWEMPLOYEE.ACCORDIONRAWEMPLOYEE.PH_5B8EC5', {
              defaultValue: 'Administrateur',
            })}
          </div>
        </div>
        <div className="footerLicence">
          <div style={{ margin: '0 4px' }}>
            <Button
              shape="round"
              style={{
                fontSize: window.screen.availHeight > 950 ? '0.9rem' : '0.85rem',
              }}
              onClick={() => {
                setVisibleAdminManagement(false);
              }}
            >
              {t('APP.ACCORDIONRAWEMPLOYEE.ACCORDIONRAWEMPLOYEE.PH_B226B2', {
                defaultValue: 'Annuler',
              })}
            </Button>
          </div>
          <div style={{ margin: '0 4px' }}>
            <Button
              shape="round"
              style={{
                fontSize: window.screen.availHeight > 950 ? '0.9rem' : '0.85rem',
              }}
              loading={isLoading}
              onClick={() => {
                patchEmployee({ employee, data: newIsAdmin });
              }}
            >
              {t('APP.ACCORDIONRAWEMPLOYEE.ACCORDIONRAWEMPLOYEE.PH_D82D39', {
                defaultValue: 'Valider',
              })}
            </Button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <AccordionDetails>
        <div className="companyAccordionRaw item">
          {/* column expand */}
          <div
            style={{ width: columnSize.expandIcon }}
            className="expandColumnWrapper"
          ></div>

          {/* column companies */}
          <div
            style={{ width: columnSize.company }}
            className="titleColumnWrapper"
          ></div>

          {/* column users */}
          <div style={{ width: columnSize.users }} className="titleColumnWrapper">
            {employee.User.firstName || employee.User.lastName ? (
              `${employee.User.firstName} ${employee.User.lastName}`
            ) : (
              <span style={{ fontStyle: 'italic', fontSize: '0.85rem' }}>
                {t('APP.ACCORDIONRAWEMPLOYEE.ACCORDIONRAWEMPLOYEE.PH_15DA93', {
                  defaultValue: 'En attente de création du compte',
                })}
              </span>
            )}
          </div>

          {/* column Mails */}
          <div style={{ width: columnSize.mails }} className="titleColumnWrapper">
            {/* <a href="mailto:henri.teinturier@nooco.com" target='_blank' rel="noreferrer" >{employee.UserEmail}</a> */}
            <a
              href={`mailto:${employee.UserEmail}`}
              target="_blank"
              rel="noreferrer"
            >
              {employee.UserEmail}
            </a>
          </div>

          {/* column Licences */}
          <div
            style={{ width: columnSize.licence, position: 'relative' }}
            className="titleColumnWrapper"
          >
            <Popover
              open={visibleLicenceManagement}
              // onVisibleChange={(visible) => setVisibleLicenceManagement(visible)}
              title="Modifier le type de licence"
              // trigger={'onclick'}
              content={renderLicenceTypeManagement}
            >
              <div
                onClick={() => {
                  setVisibleLicenceManagement(true);
                }}
                style={{ cursor: 'pointer' }}
                className={`tag ${
                  employee.licenseType === 'pro'
                    ? 'pro'
                    : employee.licenseType === 'light'
                    ? 'light'
                    : employee.licenseType === 'read'
                    ? 'readOnly'
                    : ''
                }`}
              >
                {employee.licenseType === 'pro'
                  ? 'Pro'
                  : employee.licenseType === 'light'
                  ? 'Light'
                  : employee.licenseType === 'read'
                  ? 'Read-Only'
                  : ''}
              </div>
            </Popover>
          </div>

          {/* column admin */}
          <div style={{ width: columnSize.admin }} className="titleColumnWrapper">
            <Popover
              open={visibleAdminManagement}
              // onVisibleChange={(visible) => setVisibleLicenceManagement(visible)}
              title="Modifier statut admin"
              // trigger={'onclick'}
              content={renderAdminManagement}
            >
              <Tooltip
                title={t('APP.ACCORDIONRAWEMPLOYEE.ACCORDIONRAWEMPLOYEE.PH_803F3C', {
                  defaultValue:
                    'Affecter un statut d’administrateur à l’utilisateur',
                })}
              >
                <div
                  className={`iconAdminWrapper ${employee.isAdmin ? 'isAdmin' : ''}`}
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    setVisibleAdminManagement(true);
                  }}
                >
                  <svg
                    width="40"
                    height="32"
                    viewBox="0 0 40 32"
                    fill="current"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M38.1563 23.3312C38.3188 22.45 38.3188 21.55 38.1563 20.6687L39.7688 19.7375C39.9563 19.6312 40.0375 19.4125 39.975 19.2062C39.5563 17.8562 38.8375 16.6312 37.9 15.6187C37.7563 15.4625 37.525 15.425 37.3375 15.5312L35.725 16.4625C35.0438 15.8812 34.2625 15.4312 33.4188 15.1312V13.2687C33.4188 13.0562 33.2688 12.8687 33.0625 12.825C31.6688 12.5125 30.25 12.525 28.925 12.825C28.7188 12.8687 28.5688 13.0562 28.5688 13.2687V15.1312C27.725 15.4312 26.9438 15.8812 26.2625 16.4625L24.65 15.5312C24.4688 15.425 24.2313 15.4625 24.0875 15.6187C23.15 16.6312 22.4313 17.8562 22.0125 19.2062C21.95 19.4125 22.0375 19.6312 22.2188 19.7375L23.8313 20.6687C23.6688 21.55 23.6688 22.45 23.8313 23.3312L22.2188 24.2625C22.0313 24.3687 21.95 24.5875 22.0125 24.7937C22.4313 26.1437 23.15 27.3625 24.0875 28.3812C24.2313 28.5375 24.4625 28.575 24.65 28.4687L26.2625 27.5375C26.9438 28.1187 27.725 28.5687 28.5688 28.8687V30.7312C28.5688 30.9437 28.7188 31.1312 28.925 31.175C30.3188 31.4875 31.7375 31.475 33.0625 31.175C33.2688 31.1312 33.4188 30.9437 33.4188 30.7312V28.8687C34.2625 28.5687 35.0438 28.1187 35.725 27.5375L37.3375 28.4687C37.5188 28.575 37.7563 28.5375 37.9 28.3812C38.8375 27.3687 39.5563 26.1437 39.975 24.7937C40.0375 24.5875 39.95 24.3687 39.7688 24.2625L38.1563 23.3312ZM31 25.0312C29.325 25.0312 27.9688 23.6687 27.9688 22C27.9688 20.3312 29.3313 18.9687 31 18.9687C32.6688 18.9687 34.0313 20.3312 34.0313 22C34.0313 23.6687 32.675 25.0312 31 25.0312ZM14 16C18.4188 16 22 12.4187 22 7.99997C22 3.58122 18.4188 -3.05176e-05 14 -3.05176e-05C9.58125 -3.05176e-05 6 3.58122 6 7.99997C6 12.4187 9.58125 16 14 16ZM26.575 30.1562C26.4313 30.0812 26.2875 29.9937 26.15 29.9125L25.6563 30.2C25.2813 30.4125 24.8563 30.5312 24.4313 30.5312C23.75 30.5312 23.0938 30.2437 22.625 29.7437C21.4813 28.5062 20.6063 27 20.1125 25.3937C19.7688 24.2875 20.2313 23.1187 21.2313 22.5375L21.725 22.25C21.7188 22.0875 21.7188 21.925 21.725 21.7625L21.2313 21.475C20.2313 20.9 19.7688 19.725 20.1125 18.6187C20.1688 18.4375 20.25 18.2562 20.3125 18.075C20.075 18.0562 19.8438 18 19.6 18H18.5563C17.1688 18.6375 15.625 19 14 19C12.375 19 10.8375 18.6375 9.44375 18H8.4C3.7625 18 0 21.7625 0 26.4V29C0 30.6562 1.34375 32 3 32H25C25.6313 32 26.2188 31.8 26.7 31.4687C26.625 31.2312 26.575 30.9875 26.575 30.7312V30.1562Z"
                      fill="current"
                    />
                  </svg>
                </div>
              </Tooltip>
            </Popover>
          </div>

          {/* column delete */}
          <div style={{ width: columnSize.delete }} className="titleColumnWrapper">
            <Tooltip
              title={t('APP.ACCORDIONRAWEMPLOYEE.ACCORDIONRAWEMPLOYEE.PH_B4488F', {
                defaultValue: "Retirer la licence à l'utilisateur",
              })}
            >
              <div
                className="iconTrashWrapper"
                onClick={() => {
                  // when we delete an employee of his last company we get an error message of "user was not deleted"
                  // but if we refresh the page we see that the user is deleted
                  // investigate if its a api error (back) or front (formatting mapping)
                  dispatch(
                    updateRightsValue('selectedUser', {
                      ...employee,
                      currentCompanyId: company.id,
                    })
                  );
                  dispatch(updateRightsValue('currentCompanyId', company.id));
                  dispatch(updateRightsValue('modalAccess', 'deleteEmployee'));
                }}
              >
                <svg
                  width="25"
                  height="26"
                  viewBox="0 0 30 31"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M27.9408 5.46668H23.0815V2.42963C23.0815 1.08954 21.992 0 20.6519 0H8.50372C7.16362 0 6.07408 1.08954 6.07408 2.42963V5.46668H1.21482C0.542871 5.46668 0 6.00955 0 6.68149V7.89631C0 8.06335 0.136667 8.20001 0.303704 8.20001H2.59667L3.53436 28.0547C3.5951 29.3492 4.66566 30.3704 5.96019 30.3704H23.1954C24.4937 30.3704 25.5605 29.353 25.6212 28.0547L26.5589 8.20001H28.8519C29.0189 8.20001 29.1556 8.06335 29.1556 7.89631V6.68149C29.1556 6.00955 28.6127 5.46668 27.9408 5.46668ZM8.80742 2.73334H20.3482V5.46668H8.80742V2.73334ZM22.9031 27.6371H6.25251L5.3338 8.20001H23.8218L22.9031 27.6371Z"
                    fill="#A3AED0"
                  />
                </svg>
              </div>
            </Tooltip>
          </div>
        </div>
      </AccordionDetails>
    </>
  );
};

export default AccordionRawEmployee;
